(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_690369a"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('peppi-brand-picker')) {
    class PeppiBrandPicker extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;

        if (!this.querySelector('[data-panel]')) {
          this.frame = requestAnimationFrame(() => this.connectedCallback());
          return;
        }

        if (
          !window.HTMLDialogElement ||
          typeof HTMLDialogElement.prototype.showModal !== 'function'
        ) {
          return;
        }

        this.controller = new AbortController();
        const options = { signal: this.controller.signal };

        this.details = this.querySelector('[data-all]');
        this.trigger = this.querySelector('[data-trigger]');
        this.panel = this.querySelector('[data-panel]');
        this.closeButton = this.querySelector('[data-close]');
        this.search = this.querySelector('[data-search]');
        this.searchWrap = this.querySelector('[data-search-wrap]');
        this.empty = this.querySelector('[data-empty]');
        this.scroller = this.querySelector('[data-scroll]');
        this.links = Array.from(this.querySelectorAll('[data-brand]'));

        this.dialog = document.createElement('dialog');
        this.dialog.id = `${this.id}-dialog`;
        this.dialog.className = 'pp-brands__dialog';
        this.dialog.setAttribute(
          'aria-labelledby',
          `${this.id}-dialog-title`
        );
        this.dialog.setAttribute('aria-modal', 'true');

        this.trigger.setAttribute('role', 'button');
        this.trigger.setAttribute('aria-haspopup', 'dialog');
        this.trigger.setAttribute('aria-controls', this.dialog.id);
        this.trigger.setAttribute('aria-expanded', 'false');

        this.details.open = false;
        this.dialog.append(this.panel);
        this.append(this.dialog);

        this.closeButton.hidden = false;

        if (this.searchWrap) {
          this.searchWrap.hidden = false;
        }

        this.closeButton.setAttribute('autofocus', '');

        this.trigger.addEventListener('click', event => {
          event.preventDefault();
          this.openDialog();
        }, options);

        this.closeButton.addEventListener(
          'click',
          () => this.closeDialog(),
          options
        );

        this.dialog.addEventListener('cancel', event => {
          event.preventDefault();
          this.closeDialog();
        }, options);

        this.dialog.addEventListener('keydown', event => {
          if (event.key === 'Escape') {
            event.preventDefault();
            event.stopPropagation();
            this.closeDialog();
          } else if (event.key === 'Tab') {
            const controls = Array.from(
              this.dialog.querySelectorAll(
                'button:not([disabled]), input:not([disabled]), a[href]'
              )
            ).filter(element => element.getClientRects().length > 0);

            const first = controls[0];
            const last = controls[controls.length - 1];

            if (
              event.shiftKey &&
              document.activeElement === first
            ) {
              event.preventDefault();
              last.focus();
            } else if (
              !event.shiftKey &&
              document.activeElement === last
            ) {
              event.preventDefault();
              first.focus();
            }
          }
        }, options);

        this.dialog.addEventListener('close', () => {
          if (!this.dialog.open) {
            this.restorePage();
          }
        }, options);

        this.dialog.addEventListener('pointerdown', event => {
          this.backdropPress = this.isBackdrop(event);
        }, options);

        this.dialog.addEventListener('click', event => {
          if (this.backdropPress && this.isBackdrop(event)) {
            this.closeDialog();
          }

          this.backdropPress = false;
        }, options);

        if (this.search) {
          this.search.addEventListener(
            'input',
            () => this.filterBrands(),
            options
          );
        }

        window.addEventListener(
          'pagehide',
          () => this.closeDialog(),
          options
        );
      }

      normalize(value) {
        return value
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .toLocaleLowerCase('hu')
          .replace(/-/g, ' ')
          .replace(/\s+/g, ' ')
          .trim();
      }

      filterBrands() {
        const term = this.normalize(
          this.search ? this.search.value : ''
        );

        let count = 0;

        for (const link of this.links) {
          const matches = this.normalize(
            link.dataset.brand
          ).includes(term);

          link.hidden = !matches;

          if (matches) {
            count += 1;
          }
        }

        this.empty.hidden = count > 0;
        this.scroller.scrollTop = 0;
      }

      isBackdrop(event) {
        if (event.target !== this.dialog) {
          return false;
        }

        const rect = this.dialog.getBoundingClientRect();

        return (
          event.clientX < rect.left ||
          event.clientX > rect.right ||
          event.clientY < rect.top ||
          event.clientY > rect.bottom
        );
      }

      openDialog() {
        if (this.dialog.open) return;

        if (
          PeppiBrandPicker.active &&
          PeppiBrandPicker.active !== this
        ) {
          PeppiBrandPicker.active.closeDialog();
        }

        if (this.search) {
          this.search.value = '';
        }

        this.filterBrands();
        this.dialog.showModal();
        PeppiBrandPicker.active = this;

        this.savedOverflow = [
          document.documentElement,
          document.body
        ].map(element => ({
          element,
          value: element.style.getPropertyValue('overflow'),
          priority: element.style.getPropertyPriority('overflow')
        }));

        for (const { element } of this.savedOverflow) {
          element.style.setProperty('overflow', 'hidden');
        }

        this.trigger.setAttribute('aria-expanded', 'true');
        this.closeButton.focus({ preventScroll: true });
      }

      closeDialog() {
        if (!this.dialog || !this.dialog.open) {
          return;
        }

        this.dialog.close();
        this.restorePage();

        if (this.isConnected) {
          this.trigger.focus({ preventScroll: true });
        }
      }

      restorePage() {
        if (this.savedOverflow) {
          for (const {
            element,
            value,
            priority
          } of this.savedOverflow) {
            if (value) {
              element.style.setProperty(
                'overflow',
                value,
                priority
              );
            } else {
              element.style.removeProperty('overflow');
            }
          }

          this.savedOverflow = null;
        }

        if (PeppiBrandPicker.active === this) {
          PeppiBrandPicker.active = null;
        }

        if (this.trigger) {
          this.trigger.setAttribute('aria-expanded', 'false');
        }
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);

        if (!this.controller) return;

        this.controller.abort();
        this.closeDialog();
        this.restorePage();

        this.details.append(this.panel);
        this.dialog.remove();
        this.closeButton.hidden = true;

        if (this.searchWrap) {
          this.searchWrap.hidden = true;
        }

        for (const attribute of [
          'role',
          'aria-haspopup',
          'aria-controls',
          'aria-expanded'
        ]) {
          this.trigger.removeAttribute(attribute);
        }

        this.controller = null;
      }
    }

    customElements.define(
      'peppi-brand-picker',
      PeppiBrandPicker
    );
  }
  } catch(e) { console.error(e); }
})();

})();
